module.exports = __webpack_public_path__ + "img/73.d72f523b.jpg";